import * as util from 'util';
import _ from 'lodash';
import {Component, OnInit} from '@angular/core';
import {DICTIONARY} from '../../../../../dictionary';
import {GeneralService} from '../../../../../services/generalService';
import {RouteService} from '../../../../../services/routeService';
import {NotificationService} from '../../../../../services/notificationService';
import {ComposeMessageService} from '../../../../../services/composeMessageService';
import {LookAndFeelService} from '../../../../../services/lookAndFeelService';
import {ENV_CONSTS} from '../../../../../constants';

@Component({
	selector: 'outbound-email-signatures-component',
	templateUrl: './outbound-email-signatures.component.html',
})
export class OutboundEmailSignaturesComponent implements OnInit {
	constructor(public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService,
				private composeMessageService: ComposeMessageService,
				public lfs: LookAndFeelService) {}

	dic = DICTIONARY;
	util = util;
	_ = _;
	summernoteOptions = {
		...this.gs.summernoteOptions,
		placeholder: 'Your signature body here...',
	};
	lfPageUrl = `${ENV_CONSTS.webAppUrl}/${this.dic.CONSTANTS.appStates.adminOutbound}/${this.dic.CONSTANTS.adminPages.outbound.lf}`;

	getSignaturesInProcess;
	updateSignatureInProcess;
	isFeatureEnabled;

	signatures;
	activeSignature;
	isMissingName;
	htmlFile;
	searchSignatureTxt;
	previewHtmlParsed = '';
	selectedSignatureTemplate;

	defaultSignatureTemplate = '<table cellpadding="0" cellspacing="0" style="border-collapse:collapse; font-family:Arial, Helvetica, sans-serif; font-size:13px; color:#333333;"><tbody><tr><td style="padding-right:15px; vertical-align:top;"><!-- Optional company logo --><img src="data:image/png;base64,{{COMPANY_LOGO}}" alt="Company Logo" width="180" style="border:0; display:block;"></td><td style="vertical-align:top; border-left:2px solid #0078D7; padding-left:15px;"><table cellpadding="0" cellspacing="0" style="border-collapse:collapse;"><tbody><tr><td style="font-size:16px; font-weight:bold; color:#0078D7; padding-bottom:3px;"><span style="font-family:Arial, Helvetica, sans-serif;">{{SENDER_NAME}}</span></td></tr><tr><td style="font-size:13px; color:#333333; padding-bottom:8px;"><span style="font-family:Arial, Helvetica, sans-serif;">{{SENDER_JOB_TITLE}} | {{COMPANY_NAME}}</span></td></tr><tr><td style="font-size:12px; color:#555555; line-height:18px;"><span style="font-family:Arial, Helvetica, sans-serif;">📞 +{{SENDER_PHONE}}</span><br><span style="font-family:Arial, Helvetica, sans-serif;">✉️ <a href="mailto:john_doe@company.com" style="color:#0078D7; text-decoration:none;">{{SENDER_EMAIL}}</a></span><br><span style="font-family:Arial, Helvetica, sans-serif;">🌐 <a href="{{COMPANY_URL}}" style="color:#0078D7; text-decoration:none;">{{COMPANY_URL}}</a></span></td></tr><tr><td style="padding-top:10px;"><!-- Optional social icons --><a href="https://www.linkedin.com/company/signature" style="text-decoration:none; margin-right:8px;"><img src="https://cdn-icons-png.flaticon.com/24/174/174857.png" alt="LinkedIn" width="18" style="border:0; vertical-align:middle;"></a><a href="https://x.com" style="text-decoration:none;"><img src="https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/x.svg" alt="X" width="18" style="border:0; vertical-align:middle;"></a></td></tr></tbody></table></td></tr><tr><td colspan="2" style="padding-top:10px; font-size:11px; color:#777777; font-family:Arial, Helvetica, sans-serif;"><br></td></tr></tbody></table><br>';

	// CC: ready-made signature layouts offered when creating a new signature. All use the same dynamic fields as the default template
	modernSignatureTemplate = '<table cellpadding="0" cellspacing="0" style="border-collapse:collapse; font-family:Arial, Helvetica, sans-serif; font-size:13px; color:#333333;"><tbody><tr><td style="padding-bottom:8px;"><span style="font-family:Arial, Helvetica, sans-serif; font-size:18px; font-weight:bold; color:#333333;">{{SENDER_NAME}}</span><br><span style="font-family:Arial, Helvetica, sans-serif; font-size:13px; color:#777777;">{{SENDER_JOB_TITLE}} | {{COMPANY_NAME}}</span></td></tr><tr><td style="border-top:3px solid #0078D7; padding-top:10px; font-size:12px; color:#555555; line-height:19px;"><span style="font-family:Arial, Helvetica, sans-serif;">📞 +{{SENDER_PHONE}}</span><br><span style="font-family:Arial, Helvetica, sans-serif;">✉️ <a href="mailto:{{SENDER_EMAIL}}" style="color:#0078D7; text-decoration:none;">{{SENDER_EMAIL}}</a></span><br><span style="font-family:Arial, Helvetica, sans-serif;">🌐 <a href="{{COMPANY_URL}}" style="color:#0078D7; text-decoration:none;">{{COMPANY_URL}}</a></span></td></tr><tr><td style="padding-top:12px;"><!-- Optional company logo --><img src="data:image/png;base64,{{COMPANY_LOGO}}" alt="Company Logo" width="140" style="border:0; display:block;"></td></tr></tbody></table><br>';

	minimalSignatureTemplate = '<table cellpadding="0" cellspacing="0" style="border-collapse:collapse; font-family:Arial, Helvetica, sans-serif; font-size:13px; color:#333333;"><tbody><tr><td style="font-size:13px; line-height:19px;"><span style="font-family:Arial, Helvetica, sans-serif; font-weight:bold;">{{SENDER_NAME}}</span><br><span style="font-family:Arial, Helvetica, sans-serif; color:#777777;">{{SENDER_JOB_TITLE}} | {{COMPANY_NAME}}</span><br><span style="font-family:Arial, Helvetica, sans-serif; color:#555555;">+{{SENDER_PHONE}}</span><br><a href="mailto:{{SENDER_EMAIL}}" style="font-family:Arial, Helvetica, sans-serif; color:#0078D7; text-decoration:none;">{{SENDER_EMAIL}}</a><br><a href="{{COMPANY_URL}}" style="font-family:Arial, Helvetica, sans-serif; color:#0078D7; text-decoration:none;">{{COMPANY_URL}}</a></td></tr></tbody></table><br>';

	compactSignatureTemplate = '<table cellpadding="0" cellspacing="0" style="border-collapse:collapse; font-family:Arial, Helvetica, sans-serif; font-size:13px; color:#333333;"><tbody><tr><td style="padding-bottom:8px;"><!-- Optional company logo --><img src="data:image/png;base64,{{COMPANY_LOGO}}" alt="Company Logo" width="120" style="border:0; display:block;"></td></tr><tr><td style="font-size:13px; color:#333333;"><span style="font-family:Arial, Helvetica, sans-serif; font-weight:bold;">{{SENDER_NAME}}</span><span style="font-family:Arial, Helvetica, sans-serif; color:#777777;"> · {{SENDER_JOB_TITLE}} · {{COMPANY_NAME}}</span></td></tr><tr><td style="padding-top:5px; border-top:1px solid #dddddd; font-size:12px; color:#555555;"><span style="font-family:Arial, Helvetica, sans-serif;">+{{SENDER_PHONE}} · <a href="mailto:{{SENDER_EMAIL}}" style="color:#0078D7; text-decoration:none;">{{SENDER_EMAIL}}</a> · <a href="{{COMPANY_URL}}" style="color:#0078D7; text-decoration:none;">{{COMPANY_URL}}</a></span></td></tr><tr><td style="padding-top:10px;"><!-- Optional social icons --><a href="https://www.linkedin.com/company/signature" style="text-decoration:none; margin-right:8px;"><img src="https://cdn-icons-png.flaticon.com/24/174/174857.png" alt="LinkedIn" width="18" style="border:0; vertical-align:middle;"></a><a href="https://x.com" style="text-decoration:none;"><img src="https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/x.svg" alt="X" width="18" style="border:0; vertical-align:middle;"></a></td></tr></tbody></table><br>';

	signatureTemplates = [
		{name: 'Classic', html: this.defaultSignatureTemplate},
		{name: 'Modern', html: this.modernSignatureTemplate},
		{name: 'Minimal', html: this.minimalSignatureTemplate},
		{name: 'Compact', html: this.compactSignatureTemplate}
	];

	ngOnInit() {

		this.getSignaturesInProcess = true;
		this.rs.getSignatures().then((response) => {
			this.isFeatureEnabled = response?.enabled;
			if (this.isFeatureEnabled) {
				this.signatures = response?.templates || [];
			}
			else {
				this.signatures = [{
					name: 'Example Signature',
					html: this.defaultSignatureTemplate
				}];

				setTimeout(() => {
					this.selectActiveSignature(this.signatures[0]);
				});
			}

			this.getSignaturesInProcess = false;
		}, (error) => {
			if (error && error.data && error.data.message && !error.data.display_bar) {
				this.ns.showErrorMessage(error.data.message);
			}
			this.isFeatureEnabled = 0
			this.getSignaturesInProcess = false;
		});
	}

	selectMultipleSignaturesAction = (selectedSignatures, action) => {
		switch (action) {
			case this.gs.toCapitalize(this.dic.CONSTANTS.actions.delete):
				this.deleteSignatures(selectedSignatures);
				break;
		}
	}

	showSignatureBulkActions = () => {
		return [this.gs.toCapitalize(this.dic.CONSTANTS.actions.delete)];
	}

	showSignatureActions = () => {
		return [this.gs.toCapitalize(this.dic.CONSTANTS.actions.delete)];
	}

	selectSignatureAction = (signatureObject, action) => {
		switch (action) {
			case this.gs.toCapitalize(this.dic.CONSTANTS.actions.delete):
				this.deleteSignatures([signatureObject]);
				break;
		}
	}

	selectActiveSignature = (signature) => {
		signature.soloSelected = true;
		this.activeSignature = _.cloneDeep(signature);
		this.isMissingName = false;

		const summernoteContentParts = this.composeMessageService.updateSummernoteContent(this.activeSignature.html, true);
		this.activeSignature.html = summernoteContentParts.html;
		this.activeSignature.css = summernoteContentParts.css;

		setTimeout(() => {
			this.previewSignature();
		},80);
	}

	startAddNewSignature = () => {
		this.selectedSignatureTemplate = this.signatureTemplates[0];
		this.activeSignature = {name: '', html: this.selectedSignatureTemplate.html};
		this.signatures?.forEach(signature => {
			signature.soloSelected = false
		});
		setTimeout(() => {
			document.getElementById('signatureNameInput').focus();
			this.previewSignature();
		}, 80);
	}

	selectSignatureTemplate = (signatureTemplate) => {
		if (this.selectedSignatureTemplate === signatureTemplate) {
			return;
		}

		this.selectedSignatureTemplate = signatureTemplate;
		this.activeSignature.html = signatureTemplate.html;

		setTimeout(() => {
			this.previewSignature();
		}, 80);
	}

	cancelAddNewSignature = () => {
		this.activeSignature = null;
	}

	saveSignature = () => {
		if (!this.activeSignature.name) {
			this.isMissingName = true;
			return;
		}

		if (this.activeSignature._id) {
			this.updateSignature();
		} else {
			const signatureData = _.cloneDeep(this.activeSignature);
			if (!signatureData.html || signatureData.html === '<br>') {
				this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Signature body'));
				return;
			}
			signatureData.html = this.composeMessageService.getSummernoteContent(signatureData);
			delete signatureData.css;
			this.updateSignatureInProcess = true;
			this.rs.addNewSignature(signatureData).then((response) => {
				const signatureToAdd = response;
				this.signatures.push(signatureToAdd);
				this.selectActiveSignature(signatureToAdd);
				this.updateSignatureInProcess = false;
				this.ns.showInfoMessage('Signature created');
			}, (error) => {
				this.updateSignatureInProcess = false;
			});
		}
	}

	updateSignature = () => {
		const signatureData = _.cloneDeep(this.activeSignature);
		if (!signatureData.html || signatureData.html === '<br>') {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Signature body'));
			return;
		}
		signatureData.html = this.composeMessageService.getSummernoteContent(signatureData);
		delete signatureData.css;
		this.updateSignatureInProcess = true;
		this.rs.updateSignature(this.activeSignature._id, signatureData).then((response) => {
			const signatureIndex = _.findIndex(this.signatures, {_id: this.activeSignature._id});
			if (signatureIndex >= 0) {
				this.signatures[signatureIndex] = Object.assign(this.signatures[signatureIndex], signatureData);
			}
			this.signatures[signatureIndex].isNew = false;
			this.selectActiveSignature(this.signatures[signatureIndex]);
			this.updateSignatureInProcess = false;
			this.ns.showInfoMessage('Signature updated');
		}, (error) => {
			if (error && error.data && error.data.message && !error.data.display_bar) {
				this.ns.showErrorMessage(error.data.message);
			}
			this.updateSignatureInProcess = false;
		});
	}


	searchSignatures = () => {
		this.signatures.forEach(record => {
			// search
			if (this.searchSignatureTxt) {
				const isFound = searchTextExecute(record, this.searchSignatureTxt);
				if (!isFound && !record.isNew) { // ignore contact in creation state
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}

	deleteSignatures = (signaturesToDelete) => {
		if (!signaturesToDelete?.length) {
			return;
		}
		this.gs.showPopup({
			title: signaturesToDelete.length === 1 ? 'Delete signature' : 'Delete signatures',
			subTitle: signaturesToDelete.length === 1 ? `Are you sure you want to delete "${signaturesToDelete[0].name}"?` : `Are you sure you want to delete ${signaturesToDelete.length} signatures?`,
			body: ['This action cannot be undone.'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			isFile: false,
			doneCb: () => {
				signaturesToDelete.forEach((signatureObj) => {
					this.deleteSignaturesExecute(signatureObj);
				});
			}
		});
	}

	deleteSignaturesExecute = (signatureObj) => {

		this.rs.deleteSignatures(signatureObj._id).then(() => {
			_.remove<any>(this.signatures, {_id: signatureObj._id});
			this.ns.showInfoMessage(this.dic.MESSAGES.signatureDeleted);
		}, (error) => {
			if (error && error.data && error.data.message && !error.data.display_bar) {
				this.ns.showErrorMessage(error.data.message);
			}
		});
	}

	loadHtml = () => {
		if (!this.htmlFile) {
			return;
		}
		const reader = new FileReader();
		reader.addEventListener('load', () => {
			if (reader.result) {
				const summernoteContentParts = this.composeMessageService.updateSummernoteContent(reader.result);
				this.activeSignature.html = summernoteContentParts.html;
				this.activeSignature.css = summernoteContentParts.css;
			}
		}, false);
		reader.readAsText(this.htmlFile, 'utf8');
	}

	previewSignature = () => {
		if (!this.activeSignature) {
			return;
		}

		let logo = this.lfs.logo;
		if (this.lfs.logo === this.dic.CONSTANTS.trustifiDefault.logo.svg) {
			logo = this.dic.CONSTANTS.trustifiDefault.logo.png;
		}
		const companyLogoBase64StartIdx = logo.indexOf('base64,');
		logo = logo.substring(companyLogoBase64StartIdx + 'base64,'.length);

		this.previewHtmlParsed = this.composeMessageService.getSummernoteContent(this.activeSignature)
			.replace(/{{SENDER_NAME}}/g, this.gs.userInfo.from?.length ? this.gs.userInfo.from[0].name : this.gs.userInfo.name)
			.replace(/{{SENDER_EMAIL}}/g, this.gs.userInfo.from?.length ? this.gs.userInfo.from[0].email : this.gs.userInfo.email)
			.replace(/{{SENDER_PHONE}}/g, this.gs.userInfo.from?.length && this.gs.userInfo.from[0].phone?.phone_number ? `${this.gs.userInfo.from[0].phone.country_code}-${this.gs.userInfo.from[0].phone.phone_number}` : '{{SENDER_PHONE}}')
			.replace(/{{SENDER_OFFICE_PHONE}}/g, this.gs.userInfo.from?.length && this.gs.userInfo.from[0].office_phone?.phone_number ? `${this.gs.userInfo.from[0].office_phone.country_code}-${this.gs.userInfo.from[0].office_phone.phone_number}` : '{{SENDER_PHONE}}')
			.replace(/{{SENDER_JOB_TITLE}}/g, this.gs.userInfo.job_title || '{{SENDER_JOB_TITLE}}')
			.replace(/{{COMPANY_NAME}}/g, this.gs.userInfo.plan.company_name || '{{COMPANY_NAME}}')
			.replace(/{{COMPANY_URL}}/g, this.gs.userInfo.plan.customization?.lf?.url || '{{COMPANY_URL}}')
			.replace(/{{COMPANY_LOGO}}/g, logo);
	}

	exportSignature = () => {
		const signatureHtml = this.composeMessageService.getSummernoteContent(this.activeSignature);
		this.gs.downloadClientFile(signatureHtml, this.activeSignature.name || 'signature', 'text/html');
	}

	copyDynamicField = (fieldName) => {
		this.gs.copyToClipboard(`{{${fieldName}}}`);
		this.ns.showInfoMessage(util.format(this.dic.MESSAGES.copyClipboard, "Dynamic field"));
	}

	// BUG FIX : ngfDrop must be overriding the "dragover" event listener of summernote. so we handle it manually
	toggleSummernoteDragState = (setState, event) => {
		const summernoteContainer = document.getElementById('summernoteContainer');

		if (setState && event.target.className === 'note-editable') {
			summernoteContainer.classList.add('summernote-hovered');
		}

			// (a new layer is now inserted because of the last class change so the "drag" event now passes to this new layer)
		// in case of a drag leave without dropping
		else if (!setState && (event.target.className === 'note-dropzone-message')) {
			summernoteContainer.classList.remove('summernote-hovered');
		}
	}
	//
}

function searchTextExecute(signatureObj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return (signatureObj.name && signatureObj.name.toLowerCase().indexOf(searchTerm) > -1);
}
